import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { fitToPage, goToPage } from '@/hooks/paging';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import { presentationOptions } from '@/constants/states';
import TasksFilters from './TasksFilters';
import TasksTableHeader from './TasksTableHeader';
import TasksTableRows from './TasksTableRows';

const TasksTable = ({
  category,
  canEdit,
  columns,
  currentPage,
  email,
  fetchData,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  tasks,
  togglePresentation,
  total,
}) => {
  const { items, pageNumber } = fitToPage(tasks, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper celled className="aridhia-tasks-table" sticky>
        <TasksTableHeader
          category={category}
          columns={columns}
          items={items}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          {togglePresentation && (readStatus !== states.PENDING) && (
          <ToggleCardsButton
            display={presentationOptions.TABLE}
            disabled={readStatus === states.PENDING}
            onClick={() => togglePresentation({ display: presentationOptions.CARDS })}
          />
          )}
          <TasksFilters category={category} className="aridhia-table-filter" />
        </TasksTableHeader>
        <Table.Body>
          <TasksTableRows canEdit={canEdit} category={category} items={items} columns={columns} email={email} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="tasks"
        goToPage={(args) => goToPage(fetchData, args, ref)}
        icon="tasks"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default TasksTable;
